import { useEffect } from 'react';
import Router from 'next/router';
import { getAnalyticsInstance } from '../utils/analytics';

const { handleRouteChange } = getAnalyticsInstance();
const onRouteChangeStart = (url) => {
  handleRouteChange(url);
};

const RouteListener = ({ children }) => {
  useEffect(() => {
    Router.events.on('routeChangeStart', onRouteChangeStart);

    return () => {
      Router.events.off('routeChangeStart', onRouteChangeStart);
    };
  });

  return <>{children}</>;
};

export default RouteListener;
